export function padLeft(value: number, length: number, char: string = "0") {
  return value.toString().padStart(length, char);
}
